import * as React from "react";

export interface IFtCircledIconProps {
	icon?: React.ReactNode;
	style: React.CSSProperties;
}

export function FtCircledIcon(props: IFtCircledIconProps) {
	const circleStyle: React.CSSProperties = {
		borderRadius: "50%",
		display: "inline-grid",
		alignItems: "center",
		...props.style
	};
	return (
		<label className="ftCircle ib" style={circleStyle}>
			{props.icon}
		</label>
	);
}
